<template>
  <div>
    <a-modal
      :title="isAddDevice ? '新增媒体' : '在投媒体'"
      width="1300px"
      :closable="false"
      :maskClosable="false"
      :keyboard="false"
      v-model="isMediaListModal"
      class="media_modal"
    >
      <div class="media_header">
        <a-row :gutter="24">
          <a-col :span="7">
            <span class="form-label">所在区域：</span>
            <a-cascader
              width="100%"
              :options="citySource"
              v-model="filrterkeyword.city"
              @change="filterCity"
              changeOnSelect
              placeholder="请选择所在区域"
            />
          </a-col>
          <a-col :span="10" style="display: flex; align-items: center">
            <span style="width: 95px">网点资源名称:</span>
            <a-input
              class="filter_input"
              v-model="filrterkeyword.mediaName"
              placeholder="请输入网点资源名称"
            />
          </a-col>
          <a-col :span="6">
            <a-button type="primary" @click="mediaSearch">查询</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="mediaReset"
              >重置</a-button
            >
            <a-button
              v-if="!isAddDevice"
              type="primary"
              class="add_btn"
              @click="showAddDevices"
              >新增点位</a-button
            >
          </a-col>
        </a-row>
        <div class="info_box" v-if="!isAddDevice">
          <a-icon type="info-circle" tip="Loading..." style="color: #1890ff" />
          成功下发 <span>{{ countMediaInfo.total }}</span
          >个,已删除 <span>{{ countMediaInfo.deleteCount }}</span
          >个
        </div>
      </div>
      <a-spin :spinning="tableLoading" tip="正在上传...">
        <a-table
          :columns="medialColumns"
          :dataSource="mediaList"
          class="medial_table"
          :pagination="false"
          @change="columnsFilter"
        >
          <div
            slot="filterInput"
            slot-scope="{
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }"
            style="padding: 8px"
          >
            <a-input
              :placeholder="`搜索 ${column.title}`"
              :value="selectedKeys[0]"
              @change="
                (e) => setSelectedKeys(e.target.value ? [e.target.value] : '')
              "
              @pressEnter="
                () => headerSearch(selectedKeys, confirm, column, clearFilters)
              "
              style="width: 134px; margin-bottom: 8px; display: block"
            />
            <a-button
              type="primary"
              @click="
                () => headerSearch(selectedKeys, confirm, column, clearFilters)
              "
              icon="search"
              size="small"
              style="width: 64px; margin-right: 8px"
              >搜索</a-button
            >
            <a-button
              @click="() => headerReset(clearFilters)"
              size="small"
              style="width: 64px"
              >重置</a-button
            >
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <div slot="MAC" slot-scope="row">
            <div v-if="row.key === 0" class="td_message"></div>
            <span>{{ row.MAC }}</span>
          </div>
          <template slot="action" slot-scope="row">
            <div>
              <div v-if="isAddDevice">
                <span v-if="row.isAdd" class="disabled_span">已添加</span>
                <a-popconfirm
                  v-else
                  overlayClassName="del_card"
                  @confirm="addMedia(row)"
                  okText="确认"
                  cancelText="取消"
                >
                  <div slot="title">
                    <h3>你确定添加这个设备吗？</h3>
                  </div>
                  <span class="del_btn">添加</span>
                </a-popconfirm>
              </div>
              <div v-else>
                <span v-if="row.isDelete" class="disabled_span">已删除</span>
                <a-popconfirm
                  v-else
                  overlayClassName="del_card"
                  @confirm="deleteMedia(row)"
                  okText="确认"
                  cancelText="取消"
                >
                  <div slot="title">
                    <h3 class="">你确定删除这个设备吗？</h3>
                  </div>
                  <span class="del_btn">删除</span>
                </a-popconfirm>
              </div>
            </div>
          </template>
          <template slot="devStatus" slot-scope="devStatus">
            <p>
              {{
                devStatus == 0
                  ? "设备离线"
                  : devStatus == 1
                  ? "设备在线"
                  : "离线超时"
              }}
            </p>
          </template>
        </a-table>
      </a-spin>
      <div style="text-align: right; margin-top: 16px">
        <a-pagination
          :pageSizeOptions="pageSizeOptions"
          :total="pageInfo.pageTotal"
          showSizeChanger
          showQuickJumper
          :pageSize="pageInfo.pageSize"
          v-model="pageInfo.current"
          @showSizeChange="changeSize"
          @change="changePage"
        >
        </a-pagination>
      </div>
      <template slot="footer">
        <a-button @click="closeModal">关闭</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import api from "../../commomFun/api";
import fun from "../../commomFun/stateToText";
export default {
  name: "editPullingPlanMedia",
  data() {
    return {
      apId: sessionStorage.getItem("planId"), //'AP-5155127696054e839d18e5d77ac73409',
      // 媒体编辑列表弹出框
      isMediaListModal: false,
      // 是否新增设备
      isAddDevice: false,
      // 表格loading
      tableLoading: true,
      // 分页信息
      pageSizeOptions: ["10", "20", "30", "40"],
      pageInfo: {
        pageTotal: 0,
        pageSize: 10,
        current: 1,
      },
      // 省市区下拉
      citySource: [],
      // 媒体统计信息
      countMediaInfo: {
        total: 0,
        deleteCount: 0,
      },
      // 搜索参数
      filrterkeyword: {
        city: [],
        mediaName: "",
        MAC: "",
        deviceName: "",
        deviceCode: "",
      },
      mediaList: [
        {
          key: 0,
          pointId: 1,
          MAC: "aaaaaasss",
          deviceName: "--",
          deviceCode: "--",
          TerminalType: "--",
          province: "",
          city: "--",
          area: "--",
          communityName: "--",
          doorName: "--",
        },
      ],
      // 头部自定义过滤
      filteredSelect: null,
      clearFilters: [],
      clearHeadr: null,
    };
  },
  props: {
    editMediaClick: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    editMediaClick(val) {
      console.log("editMediaClick----", val);
      if (val) {
        this.getMediaList();
        this.getCountInfo();
        this.isMediaListModal = val;
      }
    },
  },
  computed: {
    // 表头
    medialColumns() {
      let { filteredSelect, filrterkeyword } = this;
      filteredSelect = filteredSelect || {};
      filrterkeyword = filrterkeyword;
      // 表头
      const columns = [
        {
          title: "MAC",
          key: "MAC",
          scopedSlots: {
            filterDropdown: "filterInput",
            filterIcon: "filterIcon",
            filteredValue: filrterkeyword.MAC || null,
            customRender: "MAC",
          },
          width: 145,
        },
        {
          title: "点位名称",
          dataIndex: "deviceName",
          key: "deviceName",
          width: 120,
          scopedSlots: {
            filterDropdown: "filterInput",
            filterIcon: "filterIcon",
            filteredValue: filrterkeyword.deviceName || null,
            customRender: "deviceName",
          },
        },
        {
          title: "点位ID",
          dataIndex: "deviceCode",
          key: "deviceCode",
          width: 120,
          scopedSlots: {
            filterDropdown: "filterInput",
            filterIcon: "filterIcon",
            filteredValue: filrterkeyword.id || null,
            customRender: "deviceCode",
          },
        },
        {
          title: "终端型号",
          dataIndex: "TerminalType",
          key: "TerminalType",
          width: 110,
        },
        {
          title: "所属城市",
          key: "city",
          dataIndex: "city",
          width: 130,
        },
        {
          title: "区/县",
          key: "area",
          dataIndex: "area",
          width: 110,
        },
        {
          title: "网点资源",
          key: "communityName",
          dataIndex: "communityName",
          width: 150,
        },
        {
          title: "网络情况",
          key: "devStatus",
          dataIndex: "devStatus",
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: "devStatus" },
          filters: [
            { text: "设备在线", value: "1" },
            { text: "设备离线", value: "0" },
            { text: "离线超时", value: "2" },
          ],
          onFilter: (value, record) => {
            return record.devStatus == Number(value);
          },
          filterMultiple: false,
        },
        {
          title: "操作",
          key: "action",
          width: 90,
          scopedSlots: { customRender: "action" },
        },
      ];
      return columns;
    },
  },
  mounted() {
    this.getCityList();
  },
  methods: {
    //获取城市选择
    getCityList() {
      api.getApi("/machine/getAreaList").then((res) => {
        if (res.data.code === 200) {
          let areaList = [];
          let returnData = function (resData, obj) {
            for (let item of resData) {
              if (item.children) {
                let temp = {
                  value: item.key,
                  label: item.value,
                  children: [],
                };
                let childrens = returnData(item.children, temp);
                if (obj) {
                  obj.children.push(childrens);
                } else {
                  areaList.push(childrens);
                }
              } else {
                obj.children.push({
                  value: item.key,
                  label: item.value,
                });
              }
            }
            return obj;
          };
          returnData(res.data.data);
          this.citySource = areaList;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //城市模糊筛选
    filterCity(value) {
      console.log("value", value, this.filrterkeyword.city);
    },
    // 表头change
    columnsFilter(pagination, filters) {
      console.log("----parameters", pagination, filters);
      this.filteredSelect = filters;
      for (let i in filters) {
        let value = filters[i] ? filters[i][0] : "";
        if (i === "MAC") {
          this.filrterkeyword.MAC = value;
        } else if (i === "deviceName") {
          this.filrterkeyword.deviceName = value;
        } else if (i === "deviceCode") {
          this.filrterkeyword.deviceCode = value;
        }
      }
      if (this.isAddDevice) {
        this.getAddDeviceList();
      } else {
        this.getMediaList();
      }
      // this.getMediaList()
    },
    // 头部过滤确认
    headerSearch(selectedKeys, confirm, column, clearFilter) {
      this.clearFilters.push(clearFilter);
      confirm();
    },
    // 头部过滤取消
    headerReset(clearFilters) {
      clearFilters();
    },
    // 搜索
    mediaSearch() {
      this.pageInfo.current = 1;
      if (this.isAddDevice) {
        this.getAddDeviceList();
      } else {
        this.getMediaList();
      }
    },
    // 重置
    mediaReset() {
      this.initFilterInfo();
      if (this.isAddDevice) {
        this.getAddDeviceList();
      } else {
        this.getMediaList();
      }
    },
    changeSize(current, pageSize) {
      this.pageInfo.current = current;
      this.pageInfo.pageSize = pageSize;
      if (this.isAddDevice) {
        this.getAddDeviceList();
      } else {
        this.getMediaList();
      }
    },
    changePage(page) {
      this.pageInfo.current = page;
      if (this.isAddDevice) {
        this.getAddDeviceList();
      } else {
        this.getMediaList();
      }
    },
    // 获取计划投放的媒体列表
    getMediaList() {
      this.tableLoading = true;
      let params = {
        planId: this.apId,
        pageNum: this.pageInfo.current,
        pageSize: this.pageInfo.pageSize,
        mac: this.filrterkeyword.MAC,
        deviceName: this.filrterkeyword.deviceName,
        deviceCode: this.filrterkeyword.deviceCode,
        communityName: this.filrterkeyword.mediaName,
        areaCode: this.filrterkeyword.city.length
          ? String(
              this.filrterkeyword.city[this.filrterkeyword.city.length - 1]
            )
          : "",
        schStatus: 1,
      };
      for (let i in params) {
        if (!params[i]) {
          delete params[i];
        }
      }
      api.getApi("/adPlan/getAdMachineByPlanId", params).then((res) => {
        console.log("计划投放设备res", res);
        if (res.data.code === 200) {
          this.mediaList = res.data.data.list.map((item) => {
            return {
              key: item.id,
              pointId: item.id,
              MAC: item.mac || "MAC",
              deviceName: item.deviceName || "--",
              deviceCode: item.id || "--",
              TerminalType: item.deviceModelText || "--",
              province: item.provinceName,
              city: item.cityName || "--",
              area: item.areaName || "--",
              areaId: item.areaId,
              communityName: item.communityName || "--",
              doorName: item.deviceName || "--",
              isDelete: false, // 标识当前是否已删除（前台的临时标识）
              devStatus: item.onlineStatus,
            };
          });
          this.pageInfo.pageTotal = res.data.data.total;
        } else {
          this.$message.warning(res.data.msg || "获取媒体列表异常");
        }
        this.tableLoading = false;
      });
    },
    // 获取统计数据
    getCountInfo() {
      let params = {
        planId: this.apId,
      };
      api
        .getApi("/adPlan/getAdMachineCountInfoByPlanId", params)
        .then((res) => {
          console.log("获取统计数据---", res);
          if (res.data.code === 200) {
            this.countMediaInfo = {
              total: res.data.data.total,
              deleteCount: res.data.data.deleteCount,
            };
          } else {
            this.$message.warning(res.data.msg || "设备统计信息异常");
          }
        });
    },
    // 删除媒体
    deleteMedia(item) {
      console.log("删除媒体", item);
      if (!item.pointId) {
        this.$message.warning("数据异常");
        return;
      }
      let params = {
        planId: this.apId,
        pointId: item.pointId,
      };
      console.log("删除媒体params---", params);
      api.postApi_www("/adPlan/removeAdMachine", params).then((res) => {
        console.log("删除设备res", res);
        if (res.data.code === 200) {
          item.isDelete = true;
          this.$message.success("删除成功");
        } else {
          this.$message.warning(res.data.msg || "删除离线超时");
        }
      });
    },
    // 新增媒体
    addMedia(item) {
      console.log("新增媒体", item);
      let params = {
        planId: this.apId,
        pointId: item.pointId,
      };
      console.log("新增媒体params---", params);
      api.postApi_www("/adPlan/addAdMachine", params).then((res) => {
        console.log("新增设备res", res);
        if (res.data.code === 200) {
          item.isAdd = true;
          this.$message.success("添加成功");
        } else {
          this.$message.warning(res.data.msg || "新增离线超时");
        }
      });
    },
    // 显示可新增的设备列表
    showAddDevices() {
      this.initFilterInfo();
      this.isAddDevice = true;
      this.getAddDeviceList();
    },
    // 获取可添加的设备（媒体）
    getAddDeviceList() {
      this.tableLoading = true;
      let params = {
        planId: this.apId,
        communityName: this.filrterkeyword.mediaName,
        areaCode: this.filrterkeyword.city.length
          ? String(
              this.filrterkeyword.city[this.filrterkeyword.city.length - 1]
            )
          : "",
        pageNum: this.pageInfo.current,
        pageSize: this.pageInfo.pageSize,
        mac: this.filrterkeyword.MAC,
        deviceName: this.filrterkeyword.deviceName,
        deviceCode: this.filrterkeyword.deviceCode,
      };
      for (let i in params) {
        if (!params[i]) {
          delete params[i];
        }
      }
      api
        .getApi("/adPlan/getUnSelectedAdMachineInfoByApId", params)
        .then((res) => {
          console.log("新增设备列表resssssss", res);
          if (res.data.code === 200) {
            this.mediaList = res.data.data.list.map((item) => {
              return {
                key: item.id,
                pointId: item.id,
                MAC: item.mac || "--",
                deviceName: item.deviceName || item.doorControlName || "--",
                deviceCode: item.id || "--",
                // deviceCode: item.deviceCode || "--",
                TerminalType: item.version || "--",
                province: item.province,
                city: item.city,
                area: item.area,
                areaId: item.areaId,
                communityName: item.communityName || "--",
                doorName: item.doorName || "--",
                isAdd: false,
                devStatus: item.devStatus, // 标识是否已被添加
              };
            });
            this.pageInfo.pageTotal = res.data.data.total;
          } else {
            this.$message.warning(res.data.msg || "获取添加设备列表异常");
          }
          this.tableLoading = false;
        });
    },
    // 初始化分页信息、过滤条件
    initFilterInfo() {
      this.pageInfo.current = 1;
      this.pageInfo.pageSize = 10;
      for (let key in this.filrterkeyword) {
        if (key === "city") {
          this.filrterkeyword[key] = [];
        } else {
          this.filrterkeyword[key] = "";
        }
      }
      for (let key of this.clearFilters) {
        key();
      }
      this.clearFilters = [];
      this.mediaList = [];
      console.log("初始化条件---", this.filrterkeyword);
    },
    // 关闭
    closeModal() {
      if (this.isAddDevice) {
        this.isAddDevice = false;
        this.initFilterInfo();
        this.getMediaList();
      } else {
        this.isMediaListModal = false;
        this.$emit("closeEidtMedia", false);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.media_modal {
  .media_header {
    .info_box {
      height: 32px;
      background: rgba(230, 247, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(145, 213, 255, 1);
      line-height: 32px;
      padding: 0 16px;
      position: relative;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      margin-bottom: 16px;

      span {
        color: rgba(24, 144, 255, 1);
      }
    }
    /deep/ .ant-row {
      margin-bottom: 16px;
      .form-label {
        display: inline-block;
        width: 72px;

        text-align: right;
      }
      .filter_input,
      .ant-cascader-picker {
        width: calc(100% - 72px);
      }

      .add_btn {
        float: right;
        padding: 0;
        text-align: center;
      }
    }
  }
  .medial_table {
    max-height: 560px;
    min-height: 320px;
    overflow-y: auto;

    /deep/ .ant-dropdown-content {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      background: #fff;
      border-radius: 4px;
    }
    /deep/ .ant-table-tbody {
      td {
        position: relative;
        font-size: 14px;
        .td_message {
          width: 3px;
          height: 52px;
          background: rgba(24, 144, 255, 1);
          position: absolute;
          top: 1px;
          left: 3px;
          display: inline-block;
        }
        .disabled_span {
          color: rgba(0, 0, 0, 0.25);
        }
      }
    }
    .show_img_btn {
      cursor: pointer;
      color: #1890ff;
    }
    .del_btn {
      cursor: pointer;
      color: #1890ff;
    }
  }
}
</style>